<template>
	<div class="app">
		<!-- <jycheader :navIndex="0"></jycheader> -->
		<jycheader></jycheader>
		<!--新代码-->
		<div class="personal-center-box">
			<div v-if="personal === 5" class="mycart-no-tips shopping-p dis">
				<div>个人中心</div>
				<div class="shopping-top"></div>
				<div class="shopping-p dis">
					<div style="width:18px"></div>我的信息
				</div>
			</div>
            <div v-if="personal === 0" class="mycart-no-tips shopping-p dis">
				<div>个人中心</div>
				<div class="shopping-top"></div>
				<div class="shopping-p dis">
					<div style="width:18px"></div>我的订单
				</div>
			</div>
            <div v-if="personal === 1" class="mycart-no-tips shopping-p dis">
				<div>个人中心</div>
				<div class="shopping-top"></div>
				<div class="shopping-p dis">
					<div style="width:18px"></div>我的关注
				</div>
			</div>
            <div v-if="personal === 2" class="mycart-no-tips shopping-p dis">
				<div>个人中心</div>
				<div class="shopping-top"></div>
				<div class="shopping-p dis">
					<div style="width:18px"></div>我的余额
				</div><!--在线充值-->
			</div>
            <div v-if="personal === 3" class="mycart-no-tips shopping-p dis">
				<div>个人中心</div>
				<div class="shopping-top"></div>
				<div class="shopping-p dis">
					<div style="width:18px"></div>交易记录
				</div>
			</div>
            <div v-if="personal === 6" class="mycart-no-tips shopping-p dis">
				<div>个人中心</div>
				<div class="shopping-top"></div>
				<div class="shopping-p dis">
					<div style="width:18px"></div>余额明细
				</div>
			</div>
            <div v-if="personal === 7" class="mycart-no-tips shopping-p dis">
				<div>个人中心</div>
				<div class="shopping-top"></div>
				<div class="shopping-p dis">
					<div style="width:18px"></div>积分转让
				</div>
			</div>
            <div v-if="personal === 4" class="mycart-no-tips shopping-p dis">
				<div>个人中心</div>
				<div class="shopping-top"></div>
				<div class="shopping-p dis">
					<div style="width:18px"></div>账号安全
				</div>
			</div>
            <div v-if="personal === 8" class="mycart-no-tips shopping-p dis">
				<div>个人中心</div>
				<div class="shopping-top"></div>
				<div class="shopping-p dis">
					<div style="width:18px"></div>积分订单
				</div>
			</div>
            <div v-if="personal === 9" class="mycart-no-tips shopping-p dis">
				<div>个人中心</div>
				<div class="shopping-top"></div>
				<div class="shopping-p dis">
					<div style="width:18px"></div>积分转余额
				</div>
			</div>
            <div v-if="personal === 10" class="mycart-no-tips shopping-p dis">
				<div>个人中心</div>
				<div class="shopping-top"></div>
				<div class="shopping-p dis">
					<div style="width:18px"></div>用券记录
				</div>
			</div>
			<!------------------------------------------------------>
			<div class="personal-center-content">
				<div class="personal-center-navBox" style="height:420px">
					<!-- <div class="myfried-Anfu">我的账户</div> -->
					<div class="myorder-center">我的交易</div>
					<div class="order-big">
						<div class="myorder-box" @click="myorder(0)" :class="{chooseActive:menuIndex==0}">
							<span :class="{indexActive:menuIndex==0}"></span>普通订单
						</div>
                        <div class="mysave-box" @click="integralOrderClick(8)" :class="{chooseActive:menuIndex==8}">
							<span :class="{indexActive:menuIndex==8}"></span>积分订单
						</div>
						<div class="myorder-box" @click="mysave(1)" :class="{chooseActive:menuIndex==1}">
							<span :class="{indexActive:menuIndex==1}"></span>我的关注
						</div>
					</div>
					<div class="myorder-center">我的钱包</div>
					<div class="order-big">
						<div class="myorder-box" @click="onlineRecharge(2)" :class="{chooseActive:menuIndex==2}">
							<span :class="{indexActive:menuIndex==2}"></span>我的余额
						</div><!--在线充值-->
						<div class="mysave-box" @click="buyRecord(3)" :class="{chooseActive:menuIndex==3}">
							<span :class="{indexActive:menuIndex==3}"></span>充值记录
						</div>
                        <div class="myorder-box" @click="useCouponsClick(10)" :class="{chooseActive:menuIndex==10}">
							<span :class="{indexActive:menuIndex==10}"></span>用券记录
						</div>
                        <!-- <div class="myorder-box" @click="balancesDetails(6)" :class="{chooseActive:menuIndex==6}">
							<span :class="{indexActive:menuIndex==6}"></span>余额明细
						</div> -->
                        <div v-if="vipCard" class="myorder-box" @click="integralClick(7)" :class="{chooseActive:menuIndex==7}">
							<span :class="{indexActive:menuIndex==7}"></span>积分转让
						</div>
                        <div v-if="vipCard" class="myorder-box" style="line-height:2.75rem" @click="integralWithdrawClick(9)" :class="{chooseActive:menuIndex==9}">
							<span :class="{indexActive:menuIndex==9}"></span>积分转余额
						</div>
					</div>
					<div class="myorder-center">安全中心</div>
					<div class="order-big">
						<div class="myorder-box" @click="accountSecurity(4)" :class="{chooseActive:menuIndex==4}">
							<span :class="{indexActive:menuIndex==4}"></span>账户安全
						</div>
						<div class="mysave-box" @click="myInfo(5)" :class="{chooseActive:menuIndex==5}">
							<span :class="{indexActive:menuIndex==5}"></span>我的信息
						</div>
					</div>
				</div>
				<div class="personal-center-detail">
					<!--我的订单-->
                    <!--新代码-->

                    <!--??? 【组件弹窗】待发货-->




                    <!--??? 【组件弹窗】订单详情-->




                    




                    <!--订单列表-->
                    <div class="myorder-showbox" v-if="menuIndex==0">
                        <!--标题栏-->
                        <div class="or-new-wid dis">
                            <div class="or-new-p" @click="tabClick(1)" :class="is_act == 1?'or-new-act':''">普通订单</div>
                            <div class="or-new-p" @click="tabClick(2)" :class="is_act == 2?'or-new-act':''">待付款</div>
                            <!-- <div class="or-new-p" @click="tabClick(3)" :class="is_act == 3?'or-new-act':''">待发货</div> -->
                            <div class="or-new-p" @click="tabClick(4)" :class="is_act == 4?'or-new-act':''">待收货</div>
                            <div class="or-new-p" @click="tabClick(5)" :class="is_act == 5?'or-new-act':''">已完成</div>
                        </div>
                        <!--筛选-->
                        <div class="dis-between or-new-wid2">
                            <div class="dis or-new-input" style="width:360px">
                                <div class="or-new-p2">订单编号：</div>
                                <el-input placeholder="输入订单号查询" v-model="search_value" style="width:70%">
                                    <template slot="append" @click="searchNowClick" style="cursor: pointer;">查询</template>
                                </el-input>
                            </div>
                            <div class="dis or-new-input" style="width:200px">
                                <div class="or-new-p2">订单状态：</div>
                                <el-select v-model="order_status_value" placeholder="请选择" style="width:55%" @change="orderStatusClick">
                                    <el-option
                                    v-for="item in order_status_list"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="dis or-new-input" style="width:220px">
                                <div class="or-new-p2">订单日期：</div>
                                
                                <el-select v-model="orderTime" @change="chooseOrderTime" placeholder="请选择" style="width:68%">
                                    <el-option
                                    v-for="item in ordertimeData"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <!--列表-->
                        <div v-if="orderList.length > 0">
                            <div class="or-new-wid2" style="padding: 0 10px 18px 10px">
                                <div class="dis-between" style="padding:0 16px">
                                    <div class="dis">
                                        <div class="or-new-title" style="width:111px">商品信息</div>
                                        <div class="dis-between" style="width:360px">
                                            <div class="or-new-title">单价(元)</div>
                                            <div class="or-new-title">数量</div>
                                        </div>
                                    </div>
                                    <div class="or-new-title">金额(元)</div>
                                    <div class="or-new-title">操作</div>
                                </div>
                                <div class="or-new-wid3" style="margin-top:9px" v-for="(orderItem, orderIndex) in orderList" :key="orderIndex">
                                    <div class="or-new-wid4 dis-between">
                                        <div class="or-new-title-p">订单编号：{{orderItem.orderNo}} 丨 {{orderItem.addTime}}</div>
                                        <div class="dis">
                                            <!-- <div class="or-new-bottom-p" v-if="orderItem.status === 1">待支付</div> -->
                                            <div class="or-new-bottom-p2" v-if="orderItem.status === 1" @click="contPay(orderItem.qrCode, orderItem.price)">立即支付</div>
                                            <div class="or-new-bottom-p2" v-if="orderItem.status === 1" @click="cancelOrder(orderItem.id)">取消订单</div>
                                            <!---->
                                            <div class="or-new-bottom-p2" v-if="orderItem.status === 2" @click="confirmClick(orderItem.id)">确认收货</div>
                                            <!-- <div class="or-new-bottom-p2">待收货</div> -->
                                            <div class="or-new-bottom-p2" style="border:none" v-if="orderItem.status === 5">已关闭</div>
                                            <div class="or-new-bottom-p2" style="border:none" v-if="orderItem.status === 4">已完成</div>
                                        </div>
                                    </div>
                                    <div class="dis-between" style="padding:0 16px;" v-for="(orderListItem, orderListIndex) in orderItem.orderProductList" :key="orderListIndex">
                                        <div style="width:100%;" :class="orderListIndex < orderItem.orderProductList.length - 1?'or-new-num-xian':''">
                                            <div class="dis">
                                                <img class="or-new-list-img" :src="orderListItem.cover" />
                                                <div style="margin:16px 0 0 21px;width:570px">
                                                    <div style="width:360px;height:65px;">
														{{orderListItem.productName}}<span style="margin-left:10px" :class="orderListItem.type == 1?'or-new-num-col':'or-new-num-col2'">{{orderListItem.typeName}}</span>
														<!-- <div v-if="orderListItem.goodsSize" class="good-size-p2">{{orderListItem.goodsSize}}</div><div v-else class="good-size-p2">无规格</div> -->
                                                        <div class="all-com-p" style="margin: 12px 0 0 0;font-size:15px">
                                                            <span v-if="orderListItem.goodsComponent1">{{orderListItem.goodsComponent1}}</span>
                                                            <span v-if="orderListItem.goodsComponent1 && orderListItem.goodsSize"> / </span>
                                                            <span v-if="orderListItem.goodsSize">{{orderListItem.goodsSize}}</span>
                                                        </div>
                                                    </div>
                                                    
													<div class="dis-between">
                                                        
                                                        <div class="dis-between" style="width:360px">
                                                            <div v-if="orderListItem.type == 1">￥{{orderListItem.price}}
                                                                <!-- <span class="or-new-num-p">&nbsp;元/斤</span> -->
																元
                                                            </div>
                                                            <div v-else>￥{{orderListItem.discountPrice}}
                                                                <!-- <span class="or-new-num-p">&nbsp;元/斤</span> -->
																元
                                                                &nbsp;&nbsp;&nbsp;
                                                                <span style="text-decoration:line-through;color:#929292">¥{{orderListItem.price}}</span>
                                                            </div>
                                                            <div><span class="or-new-num-p">x</span>{{orderListItem.num}}</div>
                                                        </div>
                                                        <div style="color:#FF4949">￥{{orderListItem.v_subtotal}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="or-new-bottom-p2" v-if="orderListIndex === -1"></div>
                                        </div>
                                    </div>
                                    <div class="or-new-num-but dis-between">
                                        <div class="dis-between" style="width:680px;margin:auto 0">
                                            <!-- <div>返利金额&nbsp;<span style="color:#11D165">+{{orderItem.addBalance}}</span></div>
                                            <div>返利积分&nbsp;<span style="color:#e6a23c;">+{{orderItem.addTokenMoney}}</span></div> -->
                                            <div>支付类型&nbsp;&nbsp;<span v-if="orderItem.payTypeName == '扫码支付'" style="color:#e6a23c">{{orderItem.payTypeName}}</span><span v-else style="color:#11D165">{{orderItem.payTypeName}}</span></div>
                                            <div>
                                                <span style="margin-right:25px">总金额&nbsp;￥{{orderItem.price}}</span>
                                                <span style="margin-right:25px">配送费&nbsp;<span v-if="orderItem.ifUrgent" style="margin-right:10px;color:rgb(255, 73, 73)">(加急配送)</span>￥{{orderItem.delivery_money}}</span>
                                                <span>支付金额&nbsp;￥{{orderItem.payPrice}}</span>
                                            </div>
                                        </div>
                                        <div class="or-new-bottom-p2" style="margin:6px 0">订单详情</div>
                                    </div>
                                    
                                </div>
                            </div>
                            <div class="dis-end" style="margin-top:20px">
                                <div class="list-page">
                                    <el-pagination
                                        @current-change="handleCurrentChange"
                                        :current-page="currentPage"
                                        :page-size="pageSize"
                                        layout="total, prev, pager, next, jumper"
                                        :total="totalLength"
                                    ></el-pagination>
                                </div>
                            </div>
                        </div>
                        <div v-else style="background-color:#ffffff;text-align:center;">
                            <div style="height:100px;border-top:1px solid #f1f1f1"></div>
                            <div>暂无数据</div>
                            <div style="height:140px"></div>
                        </div>
                    </div>
                    <!--旧代码-->
					<!-- <div class="myorder-showbox" v-if="menuIndex==0">
						<div class="myorder-header-box">
							<div class="myorder-item">
								<el-select v-model="orderTime" placeholder="请选择" @change="chooseOrderTime">
									<el-option
										style="color: #333333;"
										v-for="(item,index) in ordertimeData"
										:key="index"
										:label="item"
										:value="index"
									></el-option>
								</el-select>
							</div>
							<div class="order-detailinfo">订单详情</div>
							<div class="order-address">收货人</div>
							<div class="order-allprice">单价</div>
							<div class="order-flag">订单状态</div>
							<div class="order-cz">操作</div>
						</div>
						<div class="myorder-items" v-for="(item,index) in orderList" :key="index">
							<div>
								<div class="myorder-items-tops">
									<div class="myorder-buytime">{{item.addTime}}</div>
									<div class="myorder-orderIndex">
										订单号：
										<span>{{item.orderNo}}</span>
									</div>
								</div>
								<div
									class="myorder-child-box"
									v-for="(itemchild,index) in item.orderProductList"
									:key="index"
								>
									<div class="myorder-child-item">
										<img :src="itemchild.cover" alt />
										<p class="foods-name">{{itemchild.productName}}</p>
										<div class="foods-price-box">
											<p class="foods-discount">￥{{itemchild.price}}</p>
										</div>
										<div class="foods-buynum">x{{itemchild.num}}</div>
									</div>
									<div class="myorder-child-name">
										{{item.addressUserName}}
										<img src="../../assets/image/img/购物车/man.png" alt />
									</div>
									<div class="myorder-child-price">
										<div class="child-discount">￥{{itemchild.price}}</div>
										<div class="child-allprice">（含运费：0.00）</div>
									</div>
									<div class="myorder-child-flag">{{item.statusName}}</div>
								</div>
							</div>
							<div class="myorder-child-buy">
								<div class="foods-buybtn" v-show="item.status==2" @click="buyAgain(index,item.id)">再次购买</div>
								<div
									class="foods-buybtn"
									v-show="item.status==1"
									@click="buyGoods(index,item.qrCode,item.orderProductList)"
								>去支付</div>
							</div>
						</div>
					</div> -->
                    <!---------------------------------------------------------------------------->
					<!-- 我的关注 -->
					<div class="mysave-showbox" v-if="menuIndex==1">
						<div class="mysave-top-box">
							<div class="choose-allitem">
								<el-checkbox v-model="checked" @change="totalchoose">全选</el-checkbox>
							</div>
							<div class="shopname">商品名称</div>
							<!-- <div class="shopnumber">数量</div> -->
							<div class="shopprice">单价</div>
							<div class="operating">操作</div>
						</div>
						<div class="mysave-item" v-for="(item,index) in saveList" :key="index">
							<div class="mysave-index">
								<el-checkbox v-model="item.flag"></el-checkbox>
							</div>
							<div class="save-line"></div>
							<div class="show-shop-box">
								<img :src="item.cover" alt />
								<p>{{item.name}}</p>
							</div>
							<div class="save-line"></div>
							<div class="mysave-shop-price">
								<div class="mysaveprice-discount">￥{{item.price}}</div>
								<div class="mysaveprice-all">￥</div>
							</div>
							<div class="save-line"></div>
							<div class="mysave-operating">
								<div class="operating-joincart" @click="join_mycart(item.goodsId, item.categoryType, item.shopId)">加入购物车</div>
								<div class="operating-cancel" @click="canceSave(item.id)">取消关注</div>
							</div>
						</div>
					</div>
					<!-- 在线充值/我的余额 -->
					<div class="online-Recharge-showbox" style="padding:0 0;background-color:#f1f1f1" v-if="menuIndex==2">
                        <!-- [备份] 在线充值(旧版) --->
						<!-- <div class="dis-between"><div class="recharge-tip">我的余额</div><div @click="buyRecord(3)" style="cursor:pointer;color:#37a115">充值记录</div></div>
						<div class="myMoney">{{myBalance}}</div>
						<div class="recharge-line"></div>
						<div class="account-recharge">充值账号:{{userName}}</div>
						<div class="recharge-money-tips">充值金额:</div>
						<div class="recharge-money-box">
							<div class="recharge-money-number" @click="choose_ten" :class="{chooseMoney:tenFlag}">
								<div v-if="tenFlag" class="choose_bg"></div>
								<img
									v-if="tenFlag"
									class="money_okimg"
									src="../../assets/image/img/购物车/ok_img.png"
									alt="img"
								/>
								<input readonly="tenvalue" placeholder="10元" type="text" />
							</div>
							<div class="recharge-money-number" @click="choose_fifty" :class="{chooseMoney:fiftyFlag}">
								<div v-if="fiftyFlag" class="choose_bg"></div>
								<img
									v-if="fiftyFlag"
									class="money_okimg"
									src="../../assets/image/img/购物车/ok_img.png"
									alt="img"
								/>
								<input readonly="fiftyvalue" placeholder="50元" type="text" />
							</div>
							<div
								class="recharge-money-number"
								@click="choose_hundred"
								:class="{chooseMoney:hundredFlag}"
							>
								<div v-if="hundredFlag" class="choose_bg"></div>
								<img
									v-if="hundredFlag"
									class="money_okimg"
									src="../../assets/image/img/购物车/ok_img.png"
									alt="img"
								/>
								<input readonly="hundervalue" placeholder="100元" type="text" />
							</div>
							<div class="recharge-money-number" @click="choose_other" :class="{chooseMoney:otherFlag}">
								<div v-if="otherFlag" class="choose_bg"></div>
								<img
									v-if="otherFlag"
									class="money_okimg"
									src="../../assets/image/img/购物车/ok_img.png"
									alt="img"
								/>
								<input placeholder="其他金额" type="text" v-model="moneyvalue" />
							</div>
						</div>
                        <div class="orderpay" v-show="payFlagPapup">
                            <div class="pay-code-box">
                                <div class="pay-code-content">
                                    <div class="pay-code-top">
                                        <p>付款</p>
                                        <p @click="closeCodePapup">×</p>
                                    </div>
                                    <div class="pay-code-price">
                                        金额:
                                        <span v-if="moneyvalue > 0">￥{{moneyvalue}}</span>
                                        <span v-else>￥{{moneydata}}</span>
                                    </div>
                                    <div class="pay-code-tips">请使用以下支付方式扫码付款</div>
                                    <div class="paytype-item">
                                        <img src="../../assets/image/img/购物车/sub-gs.png" alt />
                                        <img src="../../assets/image/img/购物车/sub-wx.png" alt />
                                        <img src="../../assets/image/img/购物车/sub-zfb.png" alt />
                                    </div>
                                    <div style="text-align:center">
                                        <vue-qr :text="qr_text" :size="150" />
                                    </div>
                                    <div class="success-btn" @click="pay_success">支付完成</div>
                                </div>
                            </div>
                        </div>
						<div class="paybtn" v-show="payFlag" @click="immediatePay">立即支付</div> -->
                        <!-- [备份] 在线充值(旧版), 末尾 --->

                        <!-- [新版] 我的余额 -->
                        <my-balance v-if="is_mybalance == 1" @childFn="balancePopup"></my-balance>
                        <user-recharge v-else-if="is_mybalance == 2" @childFn="rechargePopup"></user-recharge>
                        <withdraw-page v-else-if="is_mybalance == 3" @childFn="withdrawPopup"></withdraw-page>
                    </div>
					<!-- 充值记录 -->
					<div class="buyrecord-showbox" v-if="menuIndex==3">
						<recharge-record></recharge-record>
					</div>
                    <!--余额明细-->
                    <div class="buyrecord-showbox" v-if="menuIndex==6">
                        <balances-details></balances-details>
                    </div>
                    <!--用券记录-->
                    <div class="online-Recharge-showbox" style="padding:0 0;background-color:#f1f1f1" v-if="menuIndex==10">
                        <use-coupons></use-coupons>
                    </div>
                    <!--积分转账-->
                    <div class="buyrecord-showbox" v-if="menuIndex==7" style="background-color: #f1f1f1;padding:0 0">
                        <integral-page @childFn="integralPopup"></integral-page>
                    </div>
                    <div class="buyrecord-showbox" v-if="menuIndex==9" style="background-color: #f1f1f1;padding:0 0">
                        <integral-withdraw @childFn="integralWithdrawPopup"></integral-withdraw>
                    </div>
                    <!--积分订单-->
                    <div class="buyrecord-showbox" v-if="menuIndex==8" style="background-color: #f1f1f1;padding:0 0">
                        <integral-order @childFn="integralOrderPopup"></integral-order>
                    </div>
					<!-- 账户安全 -->
					<div class="account-showbox" v-if="menuIndex==4">
						<div class="account-top-box">
							<div class="account-top-img">
								<img src="../../assets/image/img/购物车/aqdp_img.png" alt />
							</div>
							<div class="account-top-tips">
								<p class="account-steps">
									安全等级：
									<span>高</span>
								</p>
								<p class="account-suggest">建议您启动全部安全设置,以保障账户及资金安全</p>
							</div>
						</div>
						<div class="account-item-box dis-between">
							<!-- <div class="account-item" style="margin-right:0">
								<div class="account-img"></div>
								<img class="lock" src="../../assets/image/img/购物车/lock_img.png" alt />
								<img src="../../assets/image/img/购物车/login_phone.png" alt />
								<div class="account-phone">手机号</div>
								<div class="account-phone-tips nolock">
									<img src="../../assets/image/iocn/no_lock.png" alt />
									未绑定
								</div>
								<div class="account-phone-ok">绑定手机号</div>
							</div> -->
                            <!--!用户注册需要手机号，所以默认已绑定-->
                            <div class="account-item" style="margin-right:0">
								<img src="../../assets/image/img/购物车/ok_img.png" alt class="okimg" />
								<div class="account-imgs"></div>
								<img src="../../assets/image/img/购物车/login_phone.png" alt />
								<div class="account-phone">手机号</div>
								<div class="account-phone-tips">{{myMobile}}</div>
								<div class="account-phone-ok">更换手机号</div>
							</div>
                            <!---->
							<div class="account-item" style="margin-right:0">
								<img src="../../assets/image/img/购物车/ok_img.png" alt class="okimg" />
								<div class="account-imgs"></div>
								<img src="../../assets/image/img/购物车/login_pass.png" alt />
								<div class="account-phone">登录密码</div>
								<div class="account-phone-tips">定期更换密码有助于账号安全</div>
								<div class="account-phone-ok" @click="updatePasswordClick">修改登录密码</div>
							</div>
							<div class="account-item" style="margin-right:0">
								<img src="../../assets/image/img/购物车/ok_img.png" alt class="okimg" />
								<div class="account-imgs"></div>
								<img src="../../assets/image/img/购物车/zf_password.png" alt />
								<div class="account-phone">支付密码</div>
								<div class="account-phone-tips">支付所购买商品或服务时使用</div>
								<div class="account-phone-ok" @click="setPasswordClick">设置支付密码</div>
							</div>
						</div>
                        <!-- 修改密码/设置支付密码 ------------------>
                        <update-password v-if="is_updatepassword" :parent-name="updateData" @childFn="closeUpdatePopup"></update-password>
					</div>
					<!-- 我的信息 -->
					<div class="dis-between order-add-wid" v-if="menuIndex==5">
						<div>管理收货地址</div>
						<div class="dis">
							<img
								style="width:20px;height:20px;margin:0 12px"
								src="../../assets/image/img/newimg/tianjia.png"
							/>
							<div class="add-adddress" style="color:#C80000" @click="joinAddress">添加收货地址</div>
						</div>
					</div>
					<div class="myInfo-showbox" v-if="menuIndex==5">
						<div class="dis-between" style="text-align:center">
							<div class="order-wid order-titlep">收货人</div>
							<div class="order-wid2 order-titlep">收货地址</div>
							<div class="order-wid3 order-titlep">联系电话</div>
							<div class="order-wid4 order-titlep">操作</div>
							<div class="order-wid5 order-titlep">选择</div>
						</div>
						<div class="order-title-box-wid">
							<div
								class="dis-between"
								style="border-bottom:1px solid #f1f1f1;"
								v-for="(item,index) in addressList"
								:key="index"
							>
								<div class="order-wid order-titlep">{{item.userName}}</div>
								<div
									class="order-wid2 order-titlep"
								>{{item.provinceName}}{{item.cityName}}{{item.regionName}}{{item.address}}</div>
								<div class="order-wid3 order-titlep">{{item.phone}}</div>
								<div class="order-wid4 order-titlep">
									<div class="adddress-btn">
										<div
											class="address-edit"
											@click="editAddress(index, item.id, item.userName, item.phone, item.address)"
										>修改</div>
										<div>|</div>
										<div class="address-del" @click="delAddress(item.id)">删除</div>
										<el-dialog title="提示" :visible.sync="centerDialogVisible" width="30%" center>
											<span>确定删除当前地址吗?</span>
											<span slot="footer" class="dialog-footer">
												<el-button @click="centerDialogVisible = false">取 消</el-button>
												<el-button type="primary" @click="delete_ok(item.id)">确 定</el-button>
											</span>
										</el-dialog>
									</div>
								</div>
								<div class="order-wid5 order-titlep">
									<div
										class="address-default"
										style="border: 1px solid #069338;color:#069338;width:50%;margin:0 auto"
										v-if="item.isDefault"
									>当前默认</div>
									<div class="address-default" @click="setDefaultAddress(item.id)" v-else>设为默认</div>
								</div>
							</div>
						</div>

						<!-- <div class="myInfo-top-box">
							<div class="shipping-address">收货地址</div>
							<div class="add-adddress" @click="joinAddress">添加收货地址</div>
						</div>-->
						<!-- <div
							class="address-item"
							:class="{address_active:item.isDefault}"
							v-for="(item,index) in addressList"
							:key="index"
						>
							<div class="address-top">
								<div class="adddress-userInfo-box">
									<div class="address-username">{{item.userName}}</div>
									<div class="address-phone-box">
										联系电话:
										<span>{{item.phone}}</span>
									</div>
									<div class="address-default" v-if="item.isDefault">默认地址</div>
									<div class="address-default" @click="setDefaultAddress(item.id)" v-else>设为默认地址</div>
								</div>
								<div class="adddress-btn">
									<div
										class="address-edit"
										@click="editAddress(item.id,item.userName,item.phone,item.address)"
										:class="{editActive:item.isDefault}"
									>编辑</div>
									<div
										class="address-del"
										@click="delAddress(item.id)"
										:class="{delActive:item.isDefault}"
									>删除</div>
								</div>
							</div>
							<div class="address-line"></div>
							<div class="user-detail-address">
								详细地址：
								<p>{{item.address}}</p>
							</div>
							<el-dialog title="提示" :visible.sync="centerDialogVisible" width="30%" center>
								<span>确定删除当前地址吗?</span>
								<span slot="footer" class="dialog-footer">
									<el-button @click="centerDialogVisible = false">取 消</el-button>
									<el-button type="primary" @click="delete_ok(item.id)">确 定</el-button>
								</span>
							</el-dialog>
						</div>-->
					</div>
					<!------------------------------------------>
				</div>
			</div>
            <!-- 注意 index/insidePages/addressPopup 也有一份 添加 -->
			<div class="joinAddress-box" v-if="addressFlag">
				<div class="joinaddress-content-box">
					<div class="joinaddress-top">
						<p v-if="addresstype == 1">添加收货地址</p><p v-else-if="addresstype == 2">编辑收货地址</p>
						<p @click="closeaddress">×</p>
					</div>
					<div class="receipt-box dis-between">
                        <!-- <div style="width:40%">
                            <div class="receipt-username">
                                <span>*</span>收货人
                            </div>
                            <div class="receipt-user-input">
                                <input type="text" v-model="username" />
                            </div>
                            <div class="receipt-username">
                                <span>*</span>所在地区
                            </div>
                            <div class="receipt-address-input">
                                <el-select v-model="provinceId" @change="provinces" placeholder="请选择">
                                    <el-option
                                        v-for="(item,index) in provinceList"
                                        :key="index"
                                        :label="item.name"
                                        :value="item.id"
                                    ></el-option>
                                </el-select>
                                <el-select v-model="cityId" @change="citys" placeholder="请选择">
                                    <el-option
                                        v-for="(item,index) in cityList"
                                        :key="index"
                                        :label="item.name"
                                        :value="item.id"
                                    ></el-option>
                                </el-select>
                                <el-select v-model="areaId" @change="areas" placeholder="请选择" v-if="areaList.length">
                                    <el-option
                                        v-for="(item,index) in areaList"
                                        :key="index"
                                        :label="item.name"
                                        :value="item.id"
                                    ></el-option>
                                </el-select>
                            </div>
                            <div class="receipt-username">
                                <span>*</span>详细地址
                            </div>
                            <div class="receipt-user-input" style="width: 31.125rem;">
                                <input type="text" v-model="detailaddress" style="width: 31.125rem;" />
                            </div>
                            <div class="receipt-username">
                                <span>*</span>手机号码
                            </div>
                            <div class="receipt-user-input">
                                <input type="text" v-model="userphone" />
                            </div>
                            <div class="saveAddress" @click="saveAddress">保存收货地址</div>
                        </div> -->
                        <!--新版-->
                        <div style="width:33%">
                            <div class="receipt-username">
                                <span>*</span>收货人
                            </div>
                            <div class="receipt-user-input">
                                <input type="text" v-model="username" />
                            </div>
                            <div class="receipt-username">
                                <span>*</span>手机号码
                            </div>
                            <div class="receipt-user-input">
                                <input type="text" v-model="userphone" maxlength="11" min="0" onkeyup="value=value.replace(/[^0-9]/g,'')" />
                            </div>
                            <div class="receipt-username">
                                <span>*</span>地点名称 (地图选点)
                            </div>
                            <div class="receipt-user-input">
                                <input type="text" v-model="LngLatName" disabled />
                            </div>
                            <div class="receipt-username">
                                <span>*</span>详细地址 (可补充门牌号)
                            </div>
                            <div class="receipt-textarea-input">
                                <textarea rows="4" cols="20" style="outline:none;padding:10px 10px;width:18.625rem;color:#404040;" v-model="detailaddress"></textarea>
                            </div>
                            <div style="color:#929292;font-size:12px;width:305px">Ps: 地图选位置前，可用搜索功能定位到想要选点的城市区域，再通过鼠标 (放大、缩小、移动) 地图选取位置后，在关联的列表中点击选择目标地址</div>
                            
                            <div style="width:300px;border-top:1px solid #999999;margin-top:20px"></div>
                            <div class="dis-between" style="width:300px">
                                <div class="receipt-username" style="margin:auto 30px auto 0">
                                    <span>*</span>性别
                                </div>
                                <div style="margin:10px 0">
                                    <input type="radio" v-model="sexValue" value="1"><span style="margin:0 20px 0 10px">男</span>
                                    <input type="radio" v-model="sexValue" value="2"><span style="margin:0 0 0 10px">女</span>
                                </div>
                            </div>
                            <div class="dis-between" style="width:300px">
                                <!--type 0 城市 1非城市-->
                                <div class="receipt-username" style="margin:auto 30px auto 0">
                                    <span>*</span>区域类型
                                </div>
                                <div style="margin:10px 0">
                                    <input type="radio" v-model="cityTypeValue" value="1"><span style="margin:0 20px 0 10px">城市</span>
                                    <input type="radio" v-model="cityTypeValue" value="2"><span style="margin:0 0 0 10px">非城市</span>
                                </div>
                            </div>
                            <div class="dis-between" style="width:300px">
                                <div class="receipt-username" style="margin:auto 30px auto 0">
                                    是否默认
                                </div>
                                <div style="margin:10px 0">
                                    <div v-if="!isDefaultValue" class="dis" @click="buttonClick" style="width:40px;height:20px;border-radius:30px;background-color:#f1f1f1;border:1px solid #f1f1f1">
                                        <div style="width:16px;height:16px;border-radius:50px;background-color:#929292;margin:1px 0 0 1px"></div>
                                    </div>
                                    <div v-else class="dis" @click="buttonClick" style="width:40px;height:20px;border-radius:30px;background-color:#0075ff;border:1px solid #f1f1f1">
                                        <div style="width:16px;height:16px;border-radius:50px;background-color:#ffffff;margin:1px 0 0 21px"></div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="saveAddress" style="margin: 30px 0 0 0" @click="saveAddress">保存收货地址</div>
                        </div>
                        <div style="width:67%;height:620px;margin:0 20px 0 20px">
                            <iframe id="mapPage" width="100%" height="100%" frameborder=0
                                src="https://apis.map.qq.com/tools/locpicker?search=1&center=29.076821,119.645257&type=1&key=E25BZ-BENKD-2UZ4S-HXOGB-SKWI3-NFBED&referer=myapp">
                            </iframe>
                        </div>
                    </div>
				</div>
			</div>
			<!-- 扫码支付 -->
			<div class="orderpay" v-show="submitFlag">
				<div class="pay-code-box">
					<div class="pay-code-content">
						<div class="pay-code-top">
							<p>付款</p>
							<p @click="closeCode">×</p>
						</div>
						<div class="pay-code-price">
							金额:
							<span>￥{{totalprice}}</span>
						</div>
						<div class="pay-code-tips">请使用以下支付方式扫码付款</div>
						<div class="paytype-item">
							<img src="../../assets/image/img/购物车/sub-gs.png" alt />
							<img src="../../assets/image/img/购物车/sub-wx.png" alt />
							<img src="../../assets/image/img/购物车/sub-zfb.png" alt />
						</div>
						<!-- 支付二维码 -->
                        <div style="text-align:center">
						    <vue-qr :text="qr_text" :size="150" />
                        </div>
                        <!-- <div v-else class="pay-code" id="qrcode" ref="qrcode"></div> -->
						
                        <div class="success-btn" @click="paySuccess">支付完成</div>
					</div>
				</div>
			</div>
		</div>
		<jycfooter></jycfooter>
	</div>
</template>

<script>
import jycheader from "../header.vue"
import jycfooter from "../bottom.vue"
import balancesDetails from "./components/balancesDetails"
// import QRCode from "qrcodejs2"
import vueQr from "vue-qr"
import UpdatePassword from './components/updatePassword.vue'
import MyBalance from "./components/myBalance.vue"
 import UserRecharge from "./components/userRecharge.vue"
import WithdrawPage from './components/withdrawPage.vue'
import RechargeRecord from './components/rechargeRecord.vue'
import IntegralPage from './components/integralPage.vue'
import IntegralOrder from './components/integralOrder.vue'
import IntegralWithdraw from './components/integralWithdraw.vue'
import UseCoupons from './components/useCoupons.vue'

const token = ""
export default {
	data() {
		return {
            vipCard: '',
            is_mybalance: 1,
			personal: 0,
            is_act: 1,
            search_value: '', // 搜索值
            order_status_list: [
                {value: -1,label: '全部'},
                {value: 1,label: '待付款'},
                // {value: '?',label: '待发货'},
                {value: 2,label: '待收货'},
                {value: 4,label: '已完成'},
            ],
            order_status_value: -1,
			// +---------------------------------------------
			totalprice: 0,
			submitFlag: false,
			payFlag: true, //控制充值二维码显示
			rechargeList: [], //充值记录
			addressId: 0,
			addresstype: 1,
			centerDialogVisible: false, //删除地址提示框状态
			provincename: "",
			cityname: "",
			areaname: "",
			provinceId: "",
			cityId: "",
			areaId: "",
			provinceList: [],
			cityList: [],
			areaList: [{}],
			username: "", //收货人
			userphone: "", //手机号
			detailaddress: "", //详细地址
			province: "", //省
			city: "", //市
			area: "", //区
			options: [
				{
					label: 1,
					value: 1
				}
			],
			addressFlag: false, //添加地址弹框状态
			saveList: [], //关注列表
			orderflag: false,
            // +----------------------------------
			// ordertimeData: ["近一周订单", "近一月订单", "近三月订单"],
			// orderTime: "近一周订单",
            ordertimeData: [
                {value: 0,label: '选择时间区间'},
                {value: 1,label: '近一周订单'},
                {value: 2,label: '近一月订单'},
                {value: 3,label: '近三月订单'},
            ],
            orderTime: 0,
            // +----------------------------------
			checked: false,
			pickerOptions: {
				shortcuts: [
					{
						text: "最近一周",
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(
								start.getTime() - 3600 * 1000 * 24 * 7
							)
							picker.$emit("pick", [start, end])
						}
					},
					{
						text: "最近一个月",
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(
								start.getTime() - 3600 * 1000 * 24 * 30
							)
							picker.$emit("pick", [start, end])
						}
					},
					{
						text: "最近三个月",
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(
								start.getTime() - 3600 * 1000 * 24 * 90
							)
							picker.$emit("pick", [start, end])
						}
					}
				]
			},
			value2: "",
			foundtypeData: [
				"全部",
				"下单失败",
				"未支付",
				"支付成功",
				"支付失败"
			],
			founfType: "全部",
			saveflags: false,
			saveNum: 1, //关注商品数量
			saveflag: false,
			gsflag: true,
			nyflag: false,
			wxflag: false,
			zfbflag: false,
			otherFlag: false,
			hundredFlag: false,
			fiftyFlag: false,
			tenFlag: false,
			moneyvalue: "", //充值金额
			menuIndex: 0,   // ... /  6 余额明细
			addressList: [], //我的信息
			userName: "", //充值用户名
			orderList: [], //我的订单
			moneydata: 0, //充值金额
			myBalance: 0, //余额
			nowDate: "", //当前日期
			buyList: [],
			// +---------------------------
			del_id: -1,
            qr_text: "",
            payFlagPapup: false,
            // 我的订单 +------
            currentPage: 1,
			pageSize: 5,
			totalLength: 0,
            // +---------------
            updateData: {},
            is_updatepassword: false,
            myMobile:'',
            // +------------------------------
            LngLatName: '',
            Address: '',
            LngLat: '',
            sexValue: '',
            cityTypeValue: '',
            isDefaultValue: false,
            latlngObj: {},
            lat_province_id: "",
			lat_city_id: "",
			lat_area_id: "",
		}
	},
	created() {
		// [新增] +---------------------------------------------
		window.scroll(0, 0)
        let personalValue = this.$route.query.personal
		if (personalValue) {
			localStorage.setItem("personal", personalValue)
		} else {
			localStorage.setItem("personal", 0)
		}
        let phoneValue = JSON.parse( localStorage.getItem( 'loginData2' ) ).phone
        this.myMobile = phoneValue.substr(0, 3) + '****' + phoneValue.substr(7)
        this.getcityTree()
        this.vipCard = localStorage.getItem( 'vipCard' ) != 'null' ? localStorage.getItem( 'vipCard' ) : ''

        let orderTitleValue = localStorage.getItem("orderTitleValue")
        localStorage.removeItem("orderTitleValue")
        if (orderTitleValue) this.tabClick(orderTitleValue)
		// +----------------------------------------------------
	},
	mounted() {
		this.buyList = []
		let name = localStorage.getItem("username")
		this.userName = name
		let personal = localStorage.getItem("personal")
		this.personal = Number(personal)
		this.token = localStorage.getItem("token")
		let navIndex = this.$route.query.index

		if (personal == 1) {
			this.getSaveList()
		} else if (personal == 5) {
			this.getuserAddress()
		} else if (personal == 0) {
			this.oneWeek()
		} else if (personal == 3) {
			this.getRechargeList(null)
		}
		if (personal != "" || personal != undefined || personal != null) {
			this.menuIndex = personal
		} else {
			this.menuIndex = 0
		}

        // [补充] +---------------------------------------------
        let that = this
        window.addEventListener('message', function(event) {
            // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
            var loc = event.data
            console.log(loc)
            if (loc && loc.module == 'locationPicker') {//防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
                that.LngLatName = loc.poiname
                let locpoiaddress = JSON.stringify(loc.poiaddress)
                let detailaddress = JSON.parse(locpoiaddress)
                that.detailaddress = detailaddress
                that.latlngObj = loc.latlng
                that.LngLat = loc.latlng.lng + ',' + loc.latlng.lat
            }
        }, false)
	},
	methods: {
        buttonClick() {
            this.isDefaultValue = !this.isDefaultValue
        },
        // 新增 +----------------------------------------------
        tabClick(val) {
            if (val == 1) {
                this.order_status_value = -1
            } else if (val == 2) {
                this.order_status_value = 1
            } else if (val == 3) {
                // this.order_status_value = ''
            } else if (val == 4) {
                this.order_status_value = 2
            } else if (val == 5) {
                this.order_status_value = 4
            }

            this.is_act = val
            this.orderStatusClick()
        },
        setPasswordClick() {
            this.updateData = {type: 2}
            this.is_updatepassword = true
        },
        updatePasswordClick() {
            this.updateData = {type: 1}
            this.is_updatepassword = true
        },
        closeUpdatePopup(bol) {
            this.updateData = {}
            this.is_updatepassword = false
        },
        searchNowClick() {
            this.order_status_value = this.orderTime = ''
            this.orderList = []

            let inputData = {'code': this.search_value}
            // ??? 2.呈现loading 3. 搜索接口

        },





        // 新增，末尾 +-----------------------------------------
		choosestatus(index) {
			if (index == 0) {
				this.getRechargeList(null)
			} else if (index == 1) {
				this.getRechargeList(0)
			} else if (index == 2) {
				this.getRechargeList(1)
			} else if (index == 3) {
				this.getRechargeList(2)
			} else {
				this.getRechargeList(3)
			}
			console.log(index)
		},
		closeCode() {
			this.submitFlag = false
		},
        closeCodePapup() {
            this.payFlagPapup = false
        },
		paySuccess() {
			this.submitFlag = false
            this.getorderList()
		},
		contPay(code, price) {
			//充值记录去支付
			this.totalprice = price
			if (code != "") {
				this.submitFlag = true
                // let personal = localStorage.getItem("personal")
                // this.personal = personal
                // if (personal == 0) {
                    // console.log(1)
                    this.qr_text = code
                // } else {
                    // console.log(2)
                    // const qrcode = new QRCode("qrcode", {
                    //     width: 150, // 二维码宽度
                    //     height: 150, // 二维码高度
                    //     text: code
                    // })
                // } 
			}
		},
		buyGoods(index, code, data) {
			//我的订单去支付
			let flag = this.orderList[index].orderProductList[0].invalidFlag
			let that = this
			data.forEach(function(res, index) {
				// console.log(res)
				let totalPrice = res.price * res.num
				that.buyList.push({
					id: 0,
					shopGoodsId: res.id,
					shopId: res.shopId,
					name: res.productName,
					cover: res.cover,
					price: res.price,
					num: res.num,
					allPrice: totalPrice.toFixed(2)
				})
			})
			localStorage.setItem("goodInfo", JSON.stringify(that.buyList))
			if (!flag && code != null) {
				this.$router.push({
					path: "/orderinfo",
					query: {
						type: 1
					}
				})
				localStorage.setItem("code", code)
			} else {
				this.buyList = []
				let name = "该订单包含已下架商品!请重新挑选购买!"
				this.checkTips(name, "warning")
			}
		},
		totalchoose() {
			//我的关注全选
			if (this.checked) {
				this.saveList.forEach(val => {
					val.flag = true
				})
			} else {
				this.saveList.forEach(val => {
					val.flag = false
				})
			}
		},
        cancelOrder(id) {
            this.$confirm( '确定取消订单吗？', '温馨提示',
            {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            } ).then( () =>
            {
                this.$loading();
                this.$api.product.CancelOrder(id).then((res) => {
                    this.$loading().close();
                    this.checkTips( '订单取消成功', 'success' );
                    this.orderStatusClick()
                })

            } ).catch( () =>
            {
                this.$message(
                {
                    type: 'info',
                    message: '已取消'
                } );
            } );
        },
        confirmClick(id){
            this.$confirm( '确认收货吗？', '温馨提示',
            {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            } ).then( () =>
            {
                this.$loading();
                this.$api.product.ConfirmReceipt(id).then((res) => {
                    this.$loading().close();
                    this.checkTips( '确认收货成功', 'success' );
                    this.orderStatusClick()
                })
            } ).catch( () =>
            {
                this.$message(
                {
                    type: 'info',
                    message: '已取消'
                } );
            } );
        },
        orderStatusClick() {
            this.currentPage = 1
            this.orderTime = 0
            
            if (this.order_status_value == -1) {
                this.is_act = 1
            } else if (this.order_status_value == 1) {
                this.is_act = 2
            } else if (this.order_status_value == 2) {
                this.is_act = 4
            } else if (this.order_status_value == 4) {
                this.is_act = 5
            }

            this.getorderList()
        },
		chooseOrderTime() {
			if (this.orderTime == 1) {
				this.oneWeek() //近一周订单信息
			} else if (this.orderTime == 2) {
				this.oneMonth() //近一月订单信息
			} else if (this.orderTime == 3) {
				this.threeMonth() //近三月订单信息
			}
            this.currentPage = 1
		},
		oneWeek() {
			//近一周时间
			let now = new Date()
			let oneWeek = new Date(now.getTime() - 7 * 24 * 3600 * 1000)
			let oneYear = oneWeek.getFullYear()
			let oneMonth = oneWeek.getMonth() + 1
			let oneDay = oneWeek.getDate()
			let nowyear = now.getFullYear()
			let nowMonth = now.getMonth() + 1
			let nowDay = now.getDate()
			let startdate =
				oneYear +
				"-" +
				this.getZero(oneMonth) +
				"-" +
				this.getZero(oneDay)
			let enddate =
				this.getZero(nowyear) +
				"-" +
				this.getZero(nowMonth) +
				"-" +
				this.getZero(nowDay)
			this.nowDate = enddate
			this.getorderList(startdate, this.nowDate)
		},
		oneMonth() {
			//近一月时间
			let now = new Date()
			let oneDate = new Date(now.getTime() - 30 * 24 * 3600 * 1000)
			let oneYear = oneDate.getFullYear()
			let oneMonth = oneDate.getMonth() + 1
			let oneDay = oneDate.getDate()
			let startdate =
				oneYear +
				"-" +
				this.getZero(oneMonth) +
				"-" +
				this.getZero(oneDay)
			this.getorderList(startdate, this.nowDate)
		},
		threeMonth() {
			//获取近三个月时间
			let now = new Date()
			let threeDate = new Date(now.getTime() - 90 * 24 * 3600 * 1000)
			let threeYear = threeDate.getFullYear()
			let threeMonth = threeDate.getMonth() + 1
			let threeDay = threeDate.getDate()
			let nowyear = now.getFullYear()
			let nowMonth = now.getMonth() + 1
			let nowDay = now.getDate()
			let startdate =
				threeYear +
				"-" +
				this.getZero(threeMonth) +
				"-" +
				this.getZero(threeDay)
			let enddate =
				this.getZero(nowyear) +
				"-" +
				this.getZero(nowMonth) +
				"-" +
				this.getZero(nowDay)
			this.nowDate = enddate
			this.getorderList(startdate, enddate)
		},
		getZero(num) {
			// 个位数前补0
			if (parseInt(num) < 10) {
				num = "0" + num
			}
			return num
		},
		pay_success() {
			//用户充值完成
            this.payFlagPapup = false
			this.payFlag = true
			this.getBalance()
		},
		getBalance() {
			//获取用户余额
			this.$api.order.UserBalances().then(res => {
				console.log(res)
				if (res.data.code == 0) {
					this.myBalance = res.data.result.balance
				} else {
					let name = res.data.message
					this.checkTips(name, "warning")
				}
			})
		},
		getRechargeList(status) {
			//充值记录
			this.$loading()
			let params = {
				PageNo: 1,
				PageSize: 10,
				Params: {
					DateStart: null,
					DateEnd: null,
					Status: status
				}
			}
			this.$api.order.getUserRechargeList(params).then(res => {
				this.$loading().close()
				if (res.data.code == 0) {
					this.rechargeList = res.data.result.data
				} else {
					this.checkTips(res.data.message, "warning")
				}
			})
		},
        handleCurrentChange(page) {
			this.currentPage = page
            this.getorderList()
		},
		getorderList(startdate, enddate) {
			//获取我的订单
			this.$loading()
			let params = {
				PageSize: this.pageSize,
				PageNo: this.currentPage,
				Params: {
					DateStart: startdate, //"2021-06-13",
					DateEnd: enddate //"2021-06-16",
				}
			}

            if (this.order_status_value > 0) params.Params.status = this.order_status_value

			this.$api.order.orderList(params).then(res => {
				this.$loading().close()
				if (res.data.code == 0) {
                    let listData = res.data.result.data
                    for (let i = 0; i < listData.length; i++) {
                        let orderProductList = listData[i].orderProductList
                        for (let j = 0; j < orderProductList.length; j++) {
                            let subtotalValue = 0
                            if (orderProductList[j].type == 1) {
                                subtotalValue = orderProductList[j].price * 100 * orderProductList[j].num
                            } else if (orderProductList[j].type == 2) {
                                subtotalValue = orderProductList[j].discountPrice * 100 * orderProductList[j].num
                            }
                            subtotalValue = subtotalValue / 100
                            subtotalValue = subtotalValue.toFixed(2)
                            orderProductList[j]['v_subtotal'] = subtotalValue
                        } 
                    }
					this.orderList = listData
                    this.totalLength = res.data.result.totalCount
					if (res.data.result.data == "") {
						let name = "此日期范围内你还没有订单!"
						this.checkTips(name, "warning")
					}
				} else {
					let name = res.data.message
					this.checkTips(name, "warning")
				}
				console.log(res)
			})
		},
		immediatePay() {
			//用户充值
			if (this.moneydata == 0 && this.moneyvalue == 0) {
				let name = "请选择充值金额!"
				this.checkTips(name, "warning")
			} else {
				this.$loading()
				let money = 0
				if (this.moneyvalue > 0) {
					money = Number(this.moneyvalue)
				} else {
					money = this.moneydata
				}
				let params = {
					price: money
				}
				this.$api.order.UserRecharge(params).then(res => {
					this.$loading().close()
					console.log(res)
					if (res.data.code == 0) {
						// this.payFlag = false
                        this.payFlagPapup = true
                        this.qr_text = res.data.result
						// const qrcode = new QRCode("qrcode", {
						// 	width: 150, // 二维码宽度
						// 	height: 150, // 二维码高度
						// 	text: res.data.result
						// })
					} else {
						let name = res.data.message
						this.checkTips(name, "warning")
					}
				})
			}
			console.log(this.moneyvalue)
		},
		delete_ok() {
			//用户确认删除当前地址
			this.$api.order.delAddress(this.del_id).then(res => {
				if (res.data.code == 0) {
					let name = "删除成功!"
					this.checkTips(name, "success")
					this.centerDialogVisible = false
					this.getuserAddress()
				} else {
					let name = res.data.message
					this.checkTips(name, "warning")
				}
			})
		},
		delAddress(id) {
			this.del_id = id
			//删除地址
			this.centerDialogVisible = true
		},
		editAddress(index, id, userName, phone, address) {
			//编辑地址
			this.addressFlag = true //打开编辑地址弹窗
			this.addresstype = 2 //1 添加地址 2编辑地址
			this.addressId = id //地址id
			this.userphone = phone
			this.username = userName
			this.detailaddress = address

            // [补充] +--------------------------------------------
            let objAddress = this.addressList[index]
            let laglngStr = objAddress.lngLat.split(',')
            this.lat_province_id = objAddress.province
            this.lat_city_id  = objAddress.city
            this.lat_area_id  = objAddress.region
            this.LngLatName  = objAddress.lngLatAddress

            let locpoiaddress = JSON.stringify(objAddress.address)
            let detailaddress = JSON.parse(locpoiaddress)

            this.detailaddress = detailaddress
            this.LngLat = objAddress.lngLat
            this.sexValue = objAddress.sex
            this.cityTypeValue = objAddress.type == 0?1:2   // type 0 城市 1非城市
            this.isDefaultValue = objAddress.isDefault
            this.latlngObj = {lat:laglngStr[1], lng:laglngStr[0]}

            // 新代码 +-----------------------------------
            // this.getcityTree() // 获取地区数据
            let addressList = this.addressList
            let citysChildren = []
            let areasChildren = []
            let provinces = addressList[index].province
            let citys = addressList[index].city
            let areas = addressList[index].region
            let provinceList = this.provinceList
            for (let i = 0; i < provinceList.length; i++) {
                let chockProvincesId = provinceList[i].id
                if (chockProvincesId == provinces) {
                    this.provinceId = provinces
                    this.cityList = citysChildren = provinceList[i].children
                }
            }
            for (let j = 0; j < citysChildren.length; j++) {
                let chockCitysId = citysChildren[j].id
                if (citys == chockCitysId) {
                    this.cityId = chockCitysId
                    this.areaList = areasChildren = citysChildren[j].children
                }
            }

            for (let z = 0; z < areasChildren.length; z++) {
                let chockAreasId = areasChildren[z].id
                if (areas == chockAreasId) {
                    this.areaId = chockAreasId
                }
            }

		},
		clearInfo() {
			//清除信息
			this.username = ""
			this.userphone = ""
			this.detailaddress = ""
			this.province = ""
			this.city = ""
			this.area = ""
            this.lat_province_id= ""
			this.lat_city_id= ""
			this.lat_area_id= ""
		},
		setDefaultAddress(id) {
			//将地址设置为默认地址
			this.$api.order.setdefaultAddress(id).then(res => {
				console.log(res)
				if (res.data.code == 0) {
					let name = "设置成功!"
					this.checkTips(name, "success")
					this.getuserAddress()
				} else {
					let name = res.data.message
					this.checkTips(name, "warning")
				}
			})
		},
		getuserAddress() {
			//获取用户收货地址列表
			if (this.token == "" || this.token == null) {
				let name = "登录后查看个人信息!"
				this.checkTips(name, "warning")
			} else {
				let params = {
					PageSize: 30,
					PageNo: 1
				}
				this.$api.order.getAddress(params).then(res => {
					this.$loading().close()
					if (res.data.code == 0) {
						this.addressList = res.data.result.data
					} else {
						let name = res.data.message
						this.checkTips(name, "warning")
					}
					console.log(res)
				})
			}
		},
		saveAddress() {
            // 保存用户添加的地址
			let telReg = /^1[3|4|5|6|7|8|9]\d{9}$/
			if (this.username == "") {
				let name = "收货人不能为空!"
				this.checkTips(name, "warning")
			// } else if (this.provinceId == "" || this.cityId == "") {
			// 	let name = "所在区域不能为空!"
			// 	this.checkTips(name, "warning")
			// } else if (this.areaList.length > 0 && this.areaId == "") {
			// 	let name = "所在区域不能为空!"
			// 	this.checkTips(name, "warning")
            } else if (!this.sexValue) {
                this.checkTips("请选择性别", "warning")
            } else if (!this.cityTypeValue) {
                this.checkTips("请选择区域类型", "warning")
            } else if (!this.LngLatName) {
                this.checkTips("请先地图选点", "warning")
			} else if (this.detailaddress == "") {
				let name = "详细地址不能为空!"
				this.checkTips(name, "warning")
			} else if (this.userphone == "") {
				let name = "手机号不能为空!"
				this.checkTips(name, "warning")
			} else if (!telReg.test(this.userphone)) {
				let name = "手机号格式错误!"
				this.checkTips(name, "warning")
			} else {
                // 经纬度换地址
                let url = 'https://apis.map.qq.com/ws/geocoder/v1/?location=' +this.latlngObj.lat + ',' + this.latlngObj.lng + '&key=E25BZ-BENKD-2UZ4S-HXOGB-SKWI3-NFBED&get_poi=1'
                this.$jsonp(url, {
                    output: "jsonp"
                }).then(res => {
                    // 换城市的ID
                    let dataObj = res.result.address_component
                    let inputData2 = {"ProvinceName":dataObj.province,"CityName":dataObj.city,"RegionName":dataObj.district}
                    this.$loading()
                    this.$api.order.GetRegionIdByCityName(inputData2).then(res => {
                        this.$loading().close()
                        if (res.data.code == 0) {
                            let v_obj = res.data.result
                            this.lat_province_id = v_obj.provinceId
                            this.lat_city_id = v_obj.cityId
                            this.lat_area_id =v_obj.regionId
                            this.baocunFn()
                        } else {
                            let name = res.data.message
                            this.checkTips(name, "error")
                        }
                    })
                }).catch(err => {
                    this.$loading().close()
                    alert(err)
                })
            }
		},
        baocunFn() {
            this.$loading()
            /// let address = this.provincename + this.cityname + this.areaname + this.detailaddress;
            if (this.addresstype == 1) {
                //addresstype 1 添加 2 编辑
                let params = {
                    Name:this.username,
                    Phone:this.userphone,
                    Province: this.lat_province_id,
                    City: this.lat_city_id,
                    Region: this.lat_area_id,
                    LngLatAddress:this.LngLatName,
                    Address:this.detailaddress,
                    LngLat:this.LngLat,
                    Sex: Number(this.sexValue),
                    type: Number(this.cityTypeValue) == 1?0:1,
                    IsDefault:this.isDefaultValue?true:false
                }
                this.$api.order.joinAddress(params).then(res => {
                    this.$loading().close()
                    if (res.data.code == 0) {
                        let name = "添加成功!"
                        this.checkTips(name, "success")
                        this.clearInfo()
                        this.getuserAddress()
                        this.addressFlag = false
                    } else {
                        let name = res.data.message
                        this.checkTips(name, "error")
                    }
                })
            } else {
                let params = {
                    id: this.addressId,
                    Name:this.username,
                    Phone:this.userphone,
                    Province: this.lat_province_id,
                    City: this.lat_city_id,
                    Region: this.lat_area_id,
                    LngLatAddress:this.LngLatName,
                    Address:this.detailaddress,
                    LngLat:this.LngLat,
                    Sex: Number(this.sexValue),
                    type: Number(this.cityTypeValue) == 1?0:1,
                    IsDefault:this.isDefaultValue?true:false
                }
                this.$api.order.editAddress(params).then(res => {
                    this.$loading().close()
                    if (res.data.code == 0) {
                        let name = "修改成功!"
                        this.checkTips(name, "success")
                        this.clearInfo()
                        this.getuserAddress()
                        this.addressFlag = false
                    } else {
                        let name = res.data.message
                        this.checkTips(name, "error")
                    }
                })
            }
			
        },
		getcityTree() {
			//获取省市区树
			this.$api.order.getcityTree().then(res => {
				this.$loading().close()
				console.log(res)
				if (res.data.code == 0) {
					this.provinceList = res.data.result
				} else {
					let name = res.data.message
					this.checkTips(name, "error")
				}
			})
		},
		provinces(index) {
			//省
			let r = this.provinceList.find(i => i.id == index)
			this.cityList = r.children
			this.cityId = ""
			this.areaId = ""
			this.citys(this.cityList[0].id)
		},
		citys(index) {
			//市
			this.areaList =
				this.cityList.find(i => i.id == index).children || []
			this.areas()
		},
		areas(index) {
			//区
			// this.areaId = this.areaList[ index ].id;
			// this.areaname = this.areaList[ index ].name;
			// console.log( this.areaId )
		},
		checkTips(name, type) {
			//用户提示
			this.$message({
				message: name,
				type: type
			})
		},
		closeaddress() {
			//关闭地址弹框
			this.addressFlag = false
		},
		joinAddress() {
			//打开地址弹框
			if (this.token == "" || this.token == null) {
				let name = "登录后才可以添加收货地址!"
				this.checkTips(name, "warning")
			} else {
				this.clearInfo()
				this.getcityTree()
				this.$loading()
                this.addresstype = 1
				this.addressFlag = true
                this.provinceId = ""
                this.cityId = ""
                this.areaId= ""
                this.lat_province_id= ""
                this.lat_city_id= ""
                this.lat_area_id= ""
                this.addressId = 0
                this.username = ''
                this.userphone = ''
                this.LngLatName = ''
                this.detailaddress = ''
                this.LngLat = ''
                this.sexValue = ''
                this.cityTypeValue = ''
                this.isDefaultValue = ''
			}
		},
		getSaveList() {
			//获取关注列表数据
			if (this.token == "" || this.token == null) {
				let name = "登录后查看关注商品!"
				this.checkTips(name, "warning")
			} else {
				this.$loading()
				let params = {
					PageNo: 1,
					PageSize: 10,
					Params: {
						CategoryId: null //备用 选填
					}
				}
				this.$api.product.saveList(params).then(res => {
					this.$loading().close()
					if (res.data.code == 0) {
						const { data } = res.data.result
						this.saveList = data.map(item => {
							return {
								...item,
								flag: false
							}
						})
					} else {
						let name = res.data.message
						this.checkTips(name, "warning")
					}
				})
			}
		},
		buyAgain(index, data) {
			//再次购买
			this.$loading()
			// console.log(data)
			let that = this
			this.$api.order.buyAgaindata(data).then(res => {
				this.$loading().close()
				console.log(res)
				if (res.data.code == 0) {
					let data = res.data.result.data
					data.forEach(function(res, index) {
						console.log(res)
						let totalPrice = res.price * res.num
						that.buyList.push({
							id: 0,
							shopGoodsId: res.shopGoodsId,
							shopId: res.shopId,
							name: res.productName,
							cover: res.cover,
							price: res.price,
							num: res.num,
							allPrice: totalPrice.toFixed(2)
						})
					})
					localStorage.setItem(
						"goodInfo",
						JSON.stringify(that.buyList)
					)
					let flag = data[0].invalidFlag
					if (!flag) {
						this.$router.push({
							path: "/orderinfo"
						})
					} else {
						this.buyList = []
						let name = "该订单包含已下架商品!请重新挑选购买!"
						this.checkTips(name, "warning")
					}
				}
			})
		},
		join_mycart(id, categoryType, shopId) {
			//加入购物车
			let params = {
				ShopProductId: id,
                CategoryType: categoryType,
				Num: 1,
                ShopId: shopId
			}
			this.$api.product.joinshopCart(params).then(res => {
				if (res.data.code == 0) {
					let name = "加入购物车成功，快去购物车查看吧!"
					this.checkTips(name, "success")
				} else {
					let name = res.data.message
					this.checkTips(name, "warning")
				}
			})
			// this.$router.push({
			// 	path:'/shopCart'
			// })
		},
		canceSave(id) {
			//取消关注
			this.$api.product.clickcancel(id).then(res => {
				console.log(res)
				if (res.data.code == 0) {
					let name = "取消成功!"
					this.checkTips(name, "success")
					this.getSaveList()
				} else {
					let name = res.data.message
					this.checkTips(name, "warning")
				}
			})
		},
		choose_foods() {
			//我的关注单选
			this.saveflags = !this.saveflags
		},
		saveLess() {
			if (this.saveNum > 1) {
				this.saveNum--
			}
		},
		saveAdd() {
			this.saveNum++
		},
		choose_ten() {
			//选择充值金额
            this.moneyvalue = ''
			this.moneydata = 10
			this.tenFlag = true
			this.otherFlag = false
			this.hundredFlag = false
			this.fiftyFlag = false
		},
		choose_fifty() {
            this.moneyvalue = ''
			this.moneydata = 50
			this.fiftyFlag = true
			this.otherFlag = false
			this.hundredFlag = false
			this.tenFlag = false
		},
		choose_hundred() {
            this.moneyvalue = ''
			this.moneydata = 100
			this.hundredFlag = true
			this.otherFlag = false
			this.fiftyFlag = false
			this.tenFlag = false
		},
		choose_other() {
            this.moneydata = ''
			this.otherFlag = true
			this.hundredFlag = false
			this.fiftyFlag = false
			this.tenFlag = false
		},
		myorder(index) {
			//我的订单
            this.closeAllPopup()
            this.personal = index
			localStorage.setItem("personal", index)
			this.menuIndex = index
			this.getorderList()
		},
		mysave(index) {
			//我的关注
            this.closeAllPopup()
            this.personal = index
			localStorage.setItem("personal", index)
			this.menuIndex = index
			this.getSaveList()
		},
		onlineRecharge(index) {
			//在线充值
            this.is_mybalance = 1
            this.closeAllPopup()
            this.personal = index
			localStorage.setItem("personal", index)
			this.menuIndex = index
            // this.getBalance()
		},
        balancePopup(bol) {
            if (bol == 7) {
                this.integralClick(7)
                return
            }
            if (bol == 9) {
                this.integralWithdrawClick(9)
                return
            }
            this.is_mybalance = bol
        },
        rechargePopup() {
            this.is_mybalance = 1
        },
        withdrawPopup(bol) {
            if (bol == 4) {
                this.accountSecurity(bol)
                return
            }
            this.is_mybalance = 1
        },
        integralPopup(bol) {
            if (bol == 4) {
                this.accountSecurity(bol)
                return
            }
        },
        integralWithdrawPopup(bol) {
            if (bol == 4) {
                this.accountSecurity(bol)
                return
            }
        },
        integralOrderPopup(bol) {
            // ...
        },
		buyRecord(index) {
			//交易记录
            this.closeAllPopup()
            this.personal = index
			localStorage.setItem("personal", index)
			// this.getRechargeList(null) // ! 已封装
			this.menuIndex = index
		},
        useCouponsClick(index) {
            //用券记录
            this.closeAllPopup()
            this.personal = index
			localStorage.setItem("personal", index)
			this.menuIndex = index
        },
        balancesDetails(index) {
            //余额明细
            this.closeAllPopup()
            this.personal = index
			localStorage.setItem("personal", index)
			this.menuIndex = index
        },
        integralClick(index) {
            this.closeAllPopup()
            this.personal = index
			localStorage.setItem("personal", index)
			this.menuIndex = index
        },
        integralWithdrawClick(index) {
            this.closeAllPopup()
            this.personal = index
			localStorage.setItem("personal", index)
			this.menuIndex = index
        },
        integralOrderClick(index) {
            this.closeAllPopup()
            this.personal = index
			localStorage.setItem("personal", index)
			this.menuIndex = index
        },
		accountSecurity(index) {
			//账户安全
            this.closeAllPopup()
            this.personal = index
			localStorage.setItem("personal", index)
			this.menuIndex = index
		},
		myInfo(index) {
			//我的信息
            this.closeAllPopup()
            this.personal = index
			this.$loading()
			localStorage.setItem("personal", index)
			this.menuIndex = index
			this.getuserAddress()
		},
		checkTips(message, type) {
			//用户提示信息
			this.$message({
				message: message,
				type: type
			})
		},
        closeAllPopup() {
            this.is_updatepassword = false
        }
	},
	components: {
        balancesDetails,
		jycheader,
		jycfooter,
        vueQr,
        UpdatePassword,
        MyBalance,
        UserRecharge,
        WithdrawPage,
        RechargeRecord,
        IntegralPage,
        IntegralWithdraw,
        IntegralOrder,
UseCoupons
	}
}
</script>

<style scoped="scoped">
.list-page >>> .el-pagination .btn-prev {
    margin-right:5px
}
.or-new-input >>> .el-input__inner{
    height:35px;
    line-height: 35px
}
.or-new-input >>> .el-input__icon {
    line-height: 35px
}
.orderpay {
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0;
	left: 0;
	z-index: 2;
}

.paysuccess {
	width: 9.375rem;
	height: 1.875rem;
	border-radius: 5px;
	text-align: center;
	font-size: 0.875rem;
	font-weight: 400;
	color: #ffffff;
	background-color: #37a115;
	margin: 1.25rem auto 0 auto;
	line-height: 1.875rem;
	cursor: pointer;
}

.success-btn {
	width: 9.375rem;
	height: 1.875rem;
	text-align: center;
	line-height: 1.875rem;
	margin: 1.25rem auto 0 auto;
	background-color: #37a115;
	color: #ffffff;
	font-size: 14px;
	border-radius: 0.3125rem;
	cursor: pointer;
}

.soon-pay-btn {
	width: 13.0625rem;
	height: 3.125rem;
	text-align: center;
	line-height: 3.125rem;
	color: #ffffff;
	font-size: 18px;
	background-color: #d43737;
	margin-left: 2.6875rem;
	margin-top: 2.5rem;
	cursor: pointer;
}

.submit-box {
	width: 65.625rem;
	display: flex;
	justify-content: flex-end;
	margin-bottom: 3.125rem;
}

.pay-code {
	width: 9.375rem;
	height: 9.375rem;
	/* border: 1px solid #FF0000; */
	/* border-radius: 10px; */
	margin: 1.5rem auto 0 auto;
	overflow: hidden;
}

.paytype-item img:nth-of-type(1) {
	width: 5.75rem;
	margin-right: 1rem;
}

.paytype-item img:nth-of-type(2) {
	width: 3.4375rem;
	margin-right: 1rem;
}

.paytype-item img:nth-of-type(3) {
	width: 3.5625rem;
}

.paytype-item img {
	height: 1.125rem;
}

.paytype-item {
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 0.875rem;
}

.pay-code-tips {
	margin-top: 1.875rem;
	color: #191919;
	font-size: 17px;
	text-align: center;
}

.pay-code-price span {
	color: #37a115;
	font-weight: bold;
	font-size: 2.125rem;
}

.pay-code-price {
	font-size: 24px;
	color: #191919;
	margin-top: 1.25rem;
	display: flex;
	justify-content: center;
	align-items: center;
}

.pay-code-top p:nth-of-type(2) {
	font-size: 28px;
	cursor: pointer;
}

.pay-code-top {
	display: flex;
	justify-content: space-between;
	align-items: center;
	color: #191919;
	font-size: 1rem;
}

.pay-code-content {
	width: 29.375rem;
	height: 27.5rem;
	background-color: #ffffff;
	border-radius: 0.625rem;
	border: 4px solid #b3b3b3;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	padding: 0 0.4375rem;
}

.pay-code-box {
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0;
	left: 0;
	background-color: rgba(0, 0, 0, 0.1);
	z-index: 10;
}

.pay-type-imgbox {
	margin-top: 15px;
}

.pay-type-imgbox img:nth-of-type(2) {
	margin: 0 1.25rem 0 1.25rem;
}

.pay-type-imgbox {
	display: flex;
	justify-content: center;
	align-items: center;
}

.pay-right-box p {
	color: #676767;
	font-size: 14px;
	font-weight: 400;
	text-align: center;
}

.pay-right-box {
	margin-left: 6.25rem;
}

.pay-type-box {
	display: flex;
	height: auto;
}

.receipt-address-input {
	width: 28rem;
	height: 2rem;
	color: #404040;
	display: flex;
	/* //  justify-content: space-between; */
	margin-bottom: 0.875rem;
}

.receipt-address-input >>> .el-input__icon{
    line-height: 2rem
}

.saveAddress {
	width: 7.125rem;
	height: 1.875rem;
	text-align: center;
	line-height: 1.75rem;
	border: 1px solid #cccccc;
	border-radius: 5px;
	background-color: #f5f5f5;
	color: #737373;
	font-size: 0.75rem;
	cursor: pointer;
}

.receipt-user-input {
	margin-bottom: 0.875rem;
}

input {
	-moz-appearance: none !important;
	outline: none !important;
	-moz-outline: none !important;
	padding-left: 0.625rem;
}

.receipt-user-input,
.receipt-user-input input {
	width: 18.625rem;
	height: 2rem;
	outline: none;
	box-shadow: none;
	color: #404040;
}

.receipt-textarea-input{
    margin-bottom: 0.875rem;
}
.receipt-textarea-input input {
	width: 14.625rem;
	height: 5rem;
	outline: none;
	box-shadow: none;
	color: #404040;
}
.receipt-username span {
	color: #cb0000;
	display: inline-block;
	margin-right: 0.3125rem;
}

.receipt-username {
	font-size: 12px;
	color: #404040;
	font-weight: 400;
	margin-bottom: 0.5rem;
}

.receipt-box {
	padding-left: 1.75rem;
}

.joinaddress-top p:nth-of-type(2) {
	font-size: 25px;
	cursor: pointer;
}

.joinaddress-top {
	font-size: #191919;
	font-size: 1rem;
	font-weight: 400px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0.375rem 1.6875rem 0 0.5rem;
	margin-bottom: 1.875rem;
}

.joinaddress-content-box {
	width: 75.125rem;
	height: 45.125rem;
	background-color: #ffffff;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	border-radius: 0.625rem;
	border: 7px solid #b3b3b3;
}

.joinAddress-box {
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0;
	left: 0;
	background-color: rgba(0, 0, 0, 0.1);
	z-index: 10;
}

.foods-buybtn {
	width: 5.4375rem;
	height: 1.875rem;
	text-align: center;
	line-height: 28px;
	color: #333333;
	font-size: 14px;
	border: 1px solid #dddddd;
	border-radius: 2px;
	background-color: #dddddd;
	margin-left: 1.25rem;
	cursor: pointer;
	margin-top: 3.125rem;
}

.myorder-child-flag {
	color: #333333;
	font-size: 14px;
	font-weight: 400;
	line-height: 6.25rem;
	text-align: center;
}

.child-allprice {
	color: #999999;
	font-size: 12px;
	font-weight: 400;
}

.child-discount {
	color: #cb0000;
	font-size: 14px;
	font-weight: bold;
}

.myorder-child-price {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
}

.myorder-child-name img {
	margin-left: 4px;
}

.myorder-child-flag {
	width: 5.625rem;
	height: 6.25rem;
	border-right: 1px solid #ededed;
}

.myorder-child-price {
	width: 7.5rem;
	height: 6.25rem;
	border-right: 1px solid #ededed;
}

.myorder-child-name {
	width: 7.25rem;
	height: 6.25rem;
	border-right: 1px solid #ededed;
	display: flex;
	justify-content: center;
	align-items: center;
	color: #333333;
	font-size: 14px;
}

.foods-buynum {
	color: #333333;
	font-size: 14px;
	margin-left: 1.25rem;
}

.foods-allprice {
	color: #999999;
	text-decoration: line-through;
	font-size: 12px;
}

.foods-discount {
	color: #333333;
	font-size: 14px;
}

.foods-price-box {
	width: 12.5rem;
	text-align: center;
	font-weight: 400;
}

.foods-name {
	color: #333333;
	font-size: 14px;
	font-weight: 400;
	margin-left: 1.25rem;
}

.myorder-child-item img {
	width: 5.3125rem;
	height: 4.6875rem;
	margin-left: 1.25rem;
}

.myorder-child-item {
	width: 28.5rem;
	display: flex;
	align-items: center;
	height: 6.25rem;
	border-right: 1px solid #ededed;
	padding-right: 1.25rem;
}

.myorder-child-box {
	width: 100%;
	height: auto;
	min-height: 6.625rem;
	display: flex;
	align-items: center;
}

.myorder-orderIndex span {
	color: #343434;
	font-weight: 400;
}

.myorder-orderIndex {
	margin-left: 1.875rem;
}

.myorder-buytime {
	margin-left: 1rem;
}

.myorder-items-tops {
	display: flex;
	align-items: center;
	font-size: 14px;
	font-weight: 400;
	color: #9a9a9a;
}

.myorder-items {
	width: 100%;
	height: auto;
	min-height: 9.125rem;
	background-color: #ffffff;
	margin-top: 1.125rem;
	padding-left: 13px;
	padding-top: 9px;
	display: flex;
	align-items: flex-start;
}

.order-allprice,
.order-flag,
.order-cz {
	margin-left: 4.375rem;
}

.order-address {
	margin-left: 11.25rem;
}

.order-detailinfo {
	margin-left: 8.125rem;
}

.myorder-header-box {
	width: 100%;
	height: 2.1875rem;
	background-color: #ffffff;
	padding-left: 1.25rem;
	display: flex;
	align-items: center;
	color: #666666;
	font-size: 12px;
}

.deal-bigbox {
	width: 100%;
	height: auto;
	background-color: #f3f3f3;
	padding: 0 1px 1px 1px;
}

.deal-order-item > div {
	height: 3.125rem;
	line-height: 3.125rem;
}

.deal-order-price {
	width: 9.875rem;
	color: #c10000;
	font-size: 16px;
}

.deal-order-text {
	width: 23.75rem;
	border-right: 1px dashed #e3e3e3;
}

.deal-order-type {
	width: 9.5625rem;
	border-right: 1px dashed #e3e3e3;
}

.deal-order-day {
	color: #999999;
	font-size: 12px;
	margin-top: 0.5rem;
}

.deal-order-year {
	margin-top: 0.625rem;
}

.deal-order-time {
	width: 9.8rem;
	border-right: 1px dashed #e3e3e3;
	line-height: 12px !important;
	display: flex;
	align-items: center;
	justify-content: center;
}

.deal-order-item {
	width: 100%;
	height: 5.25rem;
	background-color: #ffffff;
	display: flex;
	/* justify-content: space-between; */
	align-items: center;
	font-size: 14px;
	color: #333333;
	text-align: center;
	font-weight: 400;
	margin-bottom: 0.5rem;
}

.deal-order-num span {
	color: #069338;
}

.deal-order-num {
	display: flex;
	align-items: center;
	margin-left: 2.5rem;
}

.deal-order-left {
	color: #666666;
	font-size: 12px;
}

.deal-order-left {
	display: flex;
	align-items: center;
}

.deal-order-box {
	height: 2.25rem;
	background-color: #f3f3f3;
	display: flex;
	justify-content: space-between;
	align-items: center;
	color: #666666;
	font-size: 12px;
	padding-left: 1rem;
	padding-right: 1rem;
}

.deal-order-left .el-checkbox__inner {
	width: 14px;
	height: 14px;
}

.deal-top-money {
	width: 9.875rem;
	text-align: center;
}

.deal-top-summary {
	width: 24rem;
	border-right: 1px solid #cecece;
	text-align: center;
}

.deal-top-type {
	text-align: center;
}

.deal-top-type {
	width: 9.625rem;
	border-right: 1px solid #cecece;
}

.deal-top-time {
	width: 6.6875rem;
	border-right: 1px solid #cecece;
}

.deal-top-box {
	width: 100%;
	height: 3.5rem;
	background-color: #ffffff;
	display: flex;
	align-items: center;
	color: #333333;
	font-size: 14px;
	font-weight: 400;
	padding: 0 3.125rem;
	border: 1px solid #f3f3f3;
}

.found-time-box {
	/* width: 16.875rem; */
	height: 2.1875rem;
}

.deal-found-btn {
	width: 6.5rem;
	height: 2.1875rem;
	background-color: #37a115;
	color: #ffffff;
	font-size: 14px;
	font-weight: 400;
	text-align: center;
	line-height: 2.1875rem;
	margin-left: 0.625rem;
	cursor: pointer;
}

.deal-found-type {
	width: 6.75rem;
	height: 2.1875rem;
	margin-right: 0.625rem;
}

.transaction-record-title {
	width: 6.75rem;
	height: 2.0625rem;
	line-height: 2.0625rem;
	text-align: center;
	background-color: #ffffff;
	position: absolute;
	top: -1.0313rem;
	left: 1.875rem;
	color: #333333;
	font-size: 16px;
}

.transaction-tips {
	/* width: 53.5rem; */
	width: 100%;
	height: 4.25rem;
	border: 1px solid #ebebeb;
	position: relative;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	padding-right: 1.875rem;
	margin-bottom: 1rem;
}

.buyrecord-showbox {
	padding: 2.5rem 0.5625rem 1rem 0.75rem;
}

.operating-cancel {
	width: 5.9375rem;
	color: #666666;
	font-size: 12px;
	margin-top: 0.625rem;
	text-align: center;
	cursor: pointer;
}

.operating-joincart {
	width: 5.9375rem;
	height: 1.625rem;
	text-align: center;
	line-height: 1.625rem;
	background-color: #37a115;
	color: #ffffff;
	font-size: 12px;
	border-radius: 5px;
	cursor: pointer;
}

.mysaveprice-all {
	color: #999999;
	font-size: 12px;
	text-decoration: line-through;
	/* margin-top: 4px; */
}

.mysaveprice-discount {
	color: #cb0000;
	font-size: 14px;
	font-weight: bold;
}

.mysave-shop-price {
	text-align: center;
}

.mysave-input input:disabled {
	background-color: #ffffff;
}

.mysave-input input {
	border: 1px solid #cfcfcf;
	outline: none;
}

.mysave-input {
	margin: 0 5px;
}

.mysave-input,
.mysave-input input {
	width: 2.25rem;
	height: 1.3125rem;
	text-align: center;
	color: #333333;
	font-size: 16px;
}

.mysave-less,
.mysave-add {
	width: 1.3125rem;
	height: 1.3125rem;
	border-radius: 50%;
	border: 1px solid #cfcfcf;
	text-align: center;
	line-height: 1.1rem;
	color: #333333;
	font-size: 16px;
	cursor: pointer;
}

.mysave-operating {
	width: 11.0625rem;
	display: flex;
	justify-content: flex-end;
	align-items: flex-end;
	/* flex-wrap: wrap; */
	flex-direction: column;
}

.mysave-shop-price {
	width: 8rem;
}

.mysave-num {
	width: 10rem;
	display: flex;
	align-items: center;
	justify-content: center;
}

.show-shop-box p {
	color: #333333;
	font-size: 14px;
	font-weight: 400;
}

.show-shop-box img {
	width: 5.3125rem;
	height: 4.6875rem;
}

.show-shop-box {
	width: 19.375rem;
	display: flex;
	align-items: center;
	padding-left: 2.5rem;
	padding-right: 1.875rem;
	justify-content: space-between;
}

.save-line {
	width: 1px;
	height: 4.375rem;
	background-color: #ededed;
}

.mysave-index {
	/* width: 14px;
		height: 14px; */
	background: #f8f8f8;
	/* border: 1px solid #767676; */
	border-radius: 3px;
	margin-right: 1.25rem;
}

.mysave-item {
	width: 100%;
	height: 6.0625rem;
	background-color: #ffffff;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0 3.125rem 0 1.75rem;
	margin-bottom: 1.25rem;
}

.saveactice {
	background-color: #069338 !important;
	color: #ffffff !important;
}

.choose-allitem span i,
.mysave-index i {
	display: inline-block;
	width: 10px;
	height: 8px;
	border-top: 1px solid #ffffff;
	border-right: 1px solid #ffffff;
	transform: rotate(120deg);
	margin-bottom: 8px;
}

.choose-allitem span {
	display: inline-block;
	width: 14px;
	height: 14px;
	background: #f8f8f8;
	border: 1px solid #767676;
	border-radius: 3px;
	margin-right: 5px;
	cursor: pointer;
	text-align: center;
	line-height: 14px;
}

.choose-allitem {
	display: flex;
	align-items: center;
}

.mysave-top-box {
	display: flex;
	justify-content: space-between;
	align-items: center;
	background-color: #ffffff;
	height: 2.1875rem;
	padding: 0 6.25rem 0 1.875rem;
	color: #333333;
	font-weight: 400;
	font-size: 14px;
	margin-bottom: 1.25rem;
}

.buyrecord-showbox {
	width: 100%;
	min-height: 38.375rem;
	background-color: #ffffff;
}

.paybtn {
	width: 12.5rem;
	height: 2.75rem;
	background-color: #37a115;
	font-size: 16px;
	text-align: center;
	color: #ffffff;
	line-height: 2.75rem;
	margin-top: 4.375rem;
	cursor: pointer;
}

.paytype_img {
	position: absolute;
	top: 2px;
	right: 2px;
	width: 9px;
	height: 9px;
	z-index: 10;
}

.paytype_bg {
	width: 0;
	height: 0;
	border-left: 25px solid transparent;
	border-top: 23px solid #37a115;
	position: absolute;
	top: 0;
	right: 0;
	z-index: 9;
}

.zfbpay {
	background: url(../../assets/image/img/详情页/zfb_pay.png);
}

.wxpay {
	background: url(../../assets/image/img/详情页/wx_pay.png);
}

.nypay {
	background: url(../../assets/image/img/详情页/ny_bank.png);
}

.gspay {
	background: url(../../assets/image/img/详情页/gs_bank.png);
}

.pay-type-item {
	width: 8.75rem;
	height: 3.125rem;
	margin-right: 2.375rem;
	cursor: pointer;
	position: relative;
}

.pay-type-item-box {
	width: 100%;
	height: auto;
	display: flex;
	align-items: center;
}

.pay-type-tips {
	color: #676767;
	font-size: 14px;
	font-weight: 400;
	margin-bottom: 1.25rem;
}

.chooseMoney {
	border-color: #37a115 !important;
}

.money_okimg {
	position: absolute;
	top: 2px;
	right: 2px;
	width: 14px;
	height: 14px;
}

.choose_bg {
	width: 0;
	height: 0;
	border-top: 30px solid #37a115;
	border-left: 30px solid transparent;
	position: absolute;
	top: 0;
	right: 0;
}

.recharge-money-number input:disabled {
	background-color: #ffffff;
}

.recharge-money-number {
	border: 1px solid #cfcfcf;
	position: relative;
}

.recharge-money-number input {
	outline: none;
	width: 100%;
	height: 100%;
	border: none;
	text-align: center;
	cursor: pointer;
	color: #676767;
	font-size: 18px;
}

.recharge-money-number {
	width: 8rem;
	height: 3.125rem;
	border-radius: 0;
	margin-right: 1.25rem;
}

.recharge-money-box {
	width: 100%;
	height: auto;
	display: flex;
	align-items: center;
	margin-top: 1.625rem;
	margin-bottom: 1.875rem;
}

.recharge-money-tips {
	color: #676767;
	font-size: 14px;
	font-weight: 400;
}

.account-recharge {
	color: #676767;
	font-size: 14px;
	font-weight: 400;
	margin-bottom: 1.875rem;
}

.recharge-line {
	width: 100%;
	height: 1px;
	background-color: #cccccc;
	margin-bottom: 1.25rem;
}

.myMoney span {
	font-size: 24px;
	font-weight: 400;
}

.myMoney {
	font-size: 40px;
	font-weight: bold;
	color: #37a115;
	margin-top: 0.625rem;
	margin-bottom: 1.25rem;
}

.recharge-tip {
	color: #676767;
	font-size: 16px;
	font-weight: 400;
}

.online-Recharge-showbox {
	width: 100%;
	height: auto;
	min-height: 37.5rem;
	padding: 2.5rem 5.875rem 3.75rem 1.875rem;
	background-color: #ffffff;
}

.address_active {
	border-color: #bdd2c5 !important;
}

.delActive {
	background-color: #f7e4e4;
	color: #9f3737 !important;
	border-color: #cca6a6 !important;
}

.editActive {
	background-color: #d9ece0;
	border-color: #bdd2c5 !important;
}

.user-detail-address p {
	color: #333333;
}

.user-detail-address,
.user-detail-address p {
	font-size: 14px;
	font-weight: 400;
}

.user-detail-address {
	display: flex;
	align-items: center;
	color: #999999;
}

.address-line {
	width: 100%;
	height: 1px;
	background-color: #bfbfbf;
	opacity: 0.3;
	margin-top: 0.75rem;
	margin-bottom: 1.125rem;
}

.address-edit {
	margin-right: 5px;
}
.address-edit,
.address-del {
	width: 4.5rem;
	/* height: 2rem; */

	color: #333333;
	font-size: 14px;
	font-weight: 400;
	text-align: center;
	/* line-height: 2rem; */
	cursor: pointer;
}

.adddress-btn {
	display: flex;
	align-items: center;
}

.address-default {
	width: auto;
	height: auto;
	color: #333333;
	text-align: center;
	line-height: 1.375rem;
	font-size: 12px;
	/* border: 1px solid #bfbfbf; */
	cursor: pointer;
	/* margin-left: 1.25rem;
	padding: 1px 4px; */
}

.address-phone-box {
	font-size: 14px;
	font-weight: 400;
	color: #999999;
	margin-left: 0.9375rem;
}

.address-phone-box span {
	color: #333333;
}

.address-username {
	color: #333333;
	font-size: 18px;
	font-weight: 400;
}

.adddress-userInfo-box {
	display: flex;
	align-items: center;
}

.address-top {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.address-item {
	width: 44.375rem;
	height: 7.1875rem;
	border: 2px dashed #e9e9e9;
	margin-bottom: 1.5rem;
	padding: 0.875rem 1.625rem 1.25rem 1.25rem;
}

.shipping-address,
.add-adddress {
	color: #37a115;
	font-size: 14px;
	font-weight: 400;
	line-height: 1.25rem;
	cursor: pointer;
}

.shipping-address {
	/* text-decoration: underline; */
	border-bottom: 1px solid #37a115;
}

.myInfo-top-box {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 1.25rem;
}

.myInfo-showbox {
	width: 100%;
	height: 38.375rem;
	/* min-height: 38.375rem; */
	background-color: #ffffff;
	/* padding: 1.875rem 7.5rem 0 3rem; */
	padding: 0 13px;
	overflow: auto;
}

.nolock img {
	margin-right: 0.625rem;
}

.nolock {
	display: flex;
	align-items: center;
	justify-content: center;
}

.okimg {
	position: absolute;
	top: 4px;
	right: 4px;
	z-index: 2;
}

.lock {
	position: absolute;
	top: 4px;
	right: 4px;
	z-index: 2;
}

.account-imgs {
	width: 0;
	height: 0;
	border-top: 2.875rem solid #37a115;
	border-left: 2.5rem solid transparent;
	position: absolute;
	top: 0;
	right: 0;
}

.account-img {
	width: 0;
	height: 0;
	border-top: 2.875rem solid #b9b9b9;
	border-left: 2.5rem solid transparent;
	position: absolute;
	top: 0;
	right: 0;
}

.account-phone-ok {
	width: 12.5rem;
	height: 3rem;
	line-height: 3rem;
	margin: 1.125rem auto 0 auto;
	text-align: center;
	color: #333333;
	font-size: 16px;
	border: 1px solid #999999;
	cursor: pointer;
}

.account-phone-tips {
	color: #999999;
	font-size: 14px;
	margin-top: 0.9375rem;
}

.account-phone {
	color: #333333;
	font-size: 20px;
	margin-top: 1.25rem;
}

.account-item {
	width: 16.5rem;
	height: 100%;
	background-color: #ffffff;
	text-align: center;
	padding-top: 2.4375rem;
	margin-right: 3rem;
	position: relative;
}

.account-item-box {
	width: 100%;
	height: 18.75rem;
	margin-top: 1.25rem;
	display: flex;
}

.account-suggest {
	color: #eb8f05;
	margin-top: 0.625rem;
	font-size: 14px;
	font-weight: 400;
}

.account-steps span {
	color: #eb9000 !important;
}

.account-steps {
	color: #414141;
	font-size: 18px;
	font-weight: 400;
}

.account-top-tips {
	margin-left: 0.625rem;
}

.account-top-img,
.account-top-img img {
	width: 6.1875rem;
	height: 5.1875rem;
}

.account-top-box {
	width: 100%;
	height: 8.625rem;
	background-color: #ffffff;
	display: flex;
	align-items: center;
	padding-left: 2.5rem;
}

.personal-center-detail {
	width: 57.4375rem;
}

.chooseActive {
	color: #37a115 !important;
}

.indexActive {
	background-color: #37a115 !important;
}

/* .order-big span {
	display: inline-block;
	width: 0.25rem;
	height: 0.25rem;
	border-radius: 50%;
	background-color: #d0d0d0;
	margin-right: 0.625rem;
} */

.mysave-box,
.myorder-box {
	display: flex;
	align-items: center;
	cursor: pointer;
}

.mysave-box {
	height: 2.75rem;
	line-height: 2.75rem;
}

.myorder-box {
	width: 100%;
	/* height: 2.8125rem;
	line-height: 2.8125rem;
	border-bottom: 1px dashed #e7e7e7; */
}

.order-big {
	padding: 0 1.5625rem;
	color: #666666;
	font-size: 14px;
	font-weight: 400;
	/* height: 5.6875rem; */
	background-color: #ffffff;
}

.myorder-center {
	width: 100%;
	/* height: 2.5rem; */
	/* line-height: 34px; */
	margin: 17px 0;
	color: #333333;
	/* background-color: #f5f5f5; */
	font-size: 18px;
	font-family: PingFang SC;
	font-weight: 500;
	padding-left: 1.625rem;
}

.myfried-Anfu {
	width: 100%;
	height: 3.625rem;
	color: #333333;
	line-height: 3.625rem;
	text-align: center;
	font-size: 16px;
	font-weight: 400;
}

.personal-center-navBox {
	width: 16.8125rem;
	height: 380px;
	background-color: #ffffff;
}

.personal-center-content {
	width: 75rem;
	height: auto;
	min-height: 43.75rem;
	margin: auto;
	display: flex;
	justify-content: space-between;
	padding-bottom: 2.5rem;
}

.personal-center-box {
	width: 100%;
	height: 100%;
	background-color: #f1f1f1;
	/* padding-top: 1.875rem; */
}
.mycart-no-tips {
	width: 75rem;
	margin: auto;
	/* padding-left: 1rem; */
	font-size: 12px;
	font-family: PingFang SC;
	font-weight: 500;
	color: #999999;
	line-height: 34px;
	padding: 0.3rem 0;
}

@import "../../assets/style/base.css";
</style>

<style>
.receipt-address-input .el-select {
	margin-right: 15px;
}

.receipt-address-input .el-input__inner {
	width: 100%;
	height: 2rem;
}

.myorder-item .el-input__inner {
	width: 8.25rem;
	height: 2.1875rem;
	color: #666666;
	font-size: 12px;
	border: none;
}

.myorder-child-item .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
	background-color: #37a115;
	border-color: #37a115;
}

.myorder-items-tops .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
	background-color: #37a115;
	border-color: #37a115;
}

.el-checkbox__input.is-focus .el-checkbox__inner {
	border-color: #37a115;
}

.choose-allitem .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
	background-color: #37a115;
	border-color: #37a115;
}

.mysave-index .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
	background-color: #37a115;
	border-color: #37a115;
}

.choose-allitem .el-checkbox__inner:hover,
.mysave-index .el-checkbox__inner:hover {
	border-color: #37a115;
}

.choose-allitem .el-checkbox__input.is-checked + .el-checkbox__label,
.mysave-index .el-checkbox__input.is-checked + .el-checkbox__label {
	color: #666666;
}

.deal-order-left .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
	background-color: #37a115;
	border-color: #37a115;
}

.deal-order-left .el-checkbox__inner:hover {
	border-color: #37a115;
}

.deal-order-left .el-checkbox__input.is-checked + .el-checkbox__label {
	color: #666666;
}

.found-time-box .el-date-editor .el-range__icon,
.found-time-box .el-date-editor .el-range-separator {
	line-height: 28px;
}

.deal-found-type .el-input__inner,
.found-time-box .el-input__inner {
	height: 2.1875rem;
}

/* .found-time-box .el-input__inner {
	width: 16.875rem;
} */

.deal-found-type .el-select .el-input.is-focus .el-input__inner,
.deal-found-type .el-select .el-input__inner:focus {
	border-color: #cecece;
}
</style>